var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import ButtonComponent from "./ButtonComponent";
/**
 * This is a button that is meant to be used to execute a async action.
 * The onClick handler should return a promise. The button's behavior is to set the status as 'loading...' until the promise that was returned evluates and returns a result or throws an exception.
 * @export
 *
 * @example
 * ```
 *  <AsyncButton
 *      title="Submit"
 *      onClick={async() => {return executeAction("model", "action", {})}}
 *      icon="https://static.iviva.com/images/Adani_UXP/QR_badge_icon.svg"
 *      loadingTitle="Submitting..."
 *      className="custom-css-class"
 *  />
 * ```
 *
 * @category Buttons
 */
const AsyncButton = (props) => {
    // props
    let { icon, iconPosition = 'left' } = props, rest = __rest(props, ["icon", "iconPosition"]);
    return (_jsx(ButtonComponent, Object.assign({ leftIcon: iconPosition == 'left' ? icon : null, rightIcon: iconPosition == 'right' ? icon : null }, rest)));
};
export default AsyncButton;
